import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@mantine/core';
import { range } from 'remeda';
export const SkeletonForm = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div role="status"><Skeleton className="" height="2em" /><Skeleton className="mt-[1em] max-w-[15em]" height="1.5em" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const SkeletonList = t0 => {
  const $ = _c(5);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 3 : t1;
  const t2 = `space-y-2 ${className}`;
  let t3;
  if ($[0] !== size) {
    t3 = range(1, size).map(_temp);
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
function _temp(i) {
  return <div key={i} className="flex items-center gap-4"><Skeleton height="1.5em" width="15em" /><Skeleton height="1.5em" width="10em" /></div>;
}